/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import StandardTemplate from "./StandardTemplate";

class ObjectTemplate extends React.Component {
    static propTypes = {
        uiSchema: PropTypes.object
    };

    render() {
        if (this.props.uiSchema && this.props.uiSchema["ui:widget"]) return (<StandardTemplate {...this.props}/>);
        return this.props.children;
    }
}

export default ObjectTemplate;
